import ErrorBoundaryWithLogger from 'components/common/ErrorBoundary/ErrorBoundary';
import {
  footerTaxoCtaSelector,
  storeIdentifierNameSelector,
  footerClientLoadingSelector,
} from 'store/selectors';
import { useAppSelector } from 'store/store';
import { StoreIdentifierName } from 'types';
import BottomFooterLinks from './BottomFooterLinks';

const BottomFooterLinksContainer = () => {
  const storeIdentifierName = useAppSelector(storeIdentifierNameSelector);
  const cta = useAppSelector(footerTaxoCtaSelector);
  const isLoading = useAppSelector(footerClientLoadingSelector);

  if (!cta && isLoading) {
    return null;
  }

  if (!cta) {
    throw new Error(
      'Homr did not return any "Footer Links" cta content. Make sure the correct data is being returned!',
    );
  }
  return (
    <ErrorBoundaryWithLogger componentId="FooterPL-BottomFooterLinks">
      <BottomFooterLinks
        bottomFooterLinksData={cta}
        storeIdentifierName={storeIdentifierName as StoreIdentifierName}
      />
    </ErrorBoundaryWithLogger>
  );
};

export default BottomFooterLinksContainer;
